import React from "react";

const MasterCardSmallIcon = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Mastercard"
    >
      <rect width="24" height="16" rx="1" fill="#F6F6F9" />
      <path
        d="M14.4736 3.37988H9.51318V12.2939H14.4736V3.37988Z"
        fill="#FF5F00"
      />
      <path
        d="M9.82814 7.83688C9.82736 6.9784 10.0219 6.13099 10.397 5.35881C10.7722 4.58662 11.318 3.90991 11.9934 3.37989C11.1571 2.72254 10.1527 2.31374 9.09506 2.20022C8.03741 2.08671 6.96917 2.27304 6.01242 2.73794C5.05567 3.20284 4.24902 3.92755 3.68467 4.82922C3.12032 5.7309 2.82104 6.77316 2.82104 7.83688C2.82104 8.9006 3.12032 9.94286 3.68467 10.8445C4.24902 11.7462 5.05567 12.4709 6.01242 12.9358C6.96917 13.4007 8.03741 13.5871 9.09506 13.4735C10.1527 13.36 11.1571 12.9512 11.9934 12.2939C11.3181 11.7638 10.7722 11.0871 10.397 10.3149C10.0219 9.54276 9.82736 8.69536 9.82814 7.83688Z"
        fill="#EB001B"
      />
      <path
        d="M21.1655 7.83688C21.1655 8.90058 20.8663 9.94284 20.3019 10.8445C19.7376 11.7462 18.931 12.4709 17.9743 12.9358C17.0175 13.4007 15.9493 13.587 14.8917 13.4735C13.834 13.36 12.8297 12.9512 11.9934 12.2939C12.6681 11.7633 13.2136 11.0865 13.5887 10.3144C13.9637 9.54237 14.1586 8.69522 14.1586 7.83688C14.1586 6.97853 13.9637 6.13139 13.5887 5.35933C13.2136 4.58727 12.6681 3.91044 11.9934 3.37989C12.8297 2.72254 13.834 2.31374 14.8917 2.20022C15.9493 2.08671 17.0175 2.27305 17.9743 2.73796C18.931 3.20286 19.7376 3.92757 20.3019 4.82924C20.8663 5.73092 21.1655 6.77317 21.1655 7.83688Z"
        fill="#F79E1B"
      />
      <path
        d="M20.6247 11.3497V11.1672H20.6983V11.1301H20.5109V11.1672H20.5845V11.3497H20.6247ZM20.9885 11.3497V11.1297H20.9311L20.865 11.281L20.7989 11.1297H20.7414V11.3497H20.782V11.1838L20.844 11.3269H20.886L20.948 11.1834V11.3497H20.9885Z"
        fill="#F79E1B"
      />
    </svg>
  );
};

export default MasterCardSmallIcon;
